import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { ServicesSection } from './components/ServicesSection';
import { GallerySection } from './components/GallerySection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AuthoritySection } from './components/AuthoritySection';
import { OfferSection } from './components/OfferSection';
import { FAQSection } from './components/FAQSection';
import { UrgencySection } from './components/UrgencySection';
import { Footer } from './components/Footer';
import { BookingButton } from './components/ui/BookingButton';
export function App() {
  return <div className="min-h-screen bg-dark w-full overflow-x-hidden selection:bg-gold/30 selection:text-white" data-id="element-0">
      <BookingButton data-id="element-1" />
      <HeroSection data-id="element-2" />
      <PainSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <ServicesSection data-id="element-5" />
      <GallerySection data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <AuthoritySection data-id="element-8" />
      <OfferSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <UrgencySection data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}